// @flow
import HlsjsVideoStreamer from '../components/player/VideoStreamer/HlsjsVideoStreamer/HlsjsVideoStreamer';
export default HlsjsVideoStreamer;
